import React, { useState } from "react";
import {
  Grid,
  PersonBadge,
  People,
  Layers,
  ThreeDots,
  Boxes,
  GridFill,
} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CONFIG from "../../config";

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);
  let auth = useSelector((x) => x.auth.value);

  const isRouteActive = (paths) => {
    return paths.some((path) => location.pathname.startsWith(path));
  };

  const navItemsFull = [
    {
      name: t("dashboard"),
      icon: <Grid />,
      path: "/dashboard",
      activePaths: ["/dashboard", "/pending-order"],
    },
    ...(Number(auth?.user?.role_id) !== Number(CONFIG.ROLE_CUSTOMER)
      ? [
          {
            name: t("storeOwner"),
            icon: <People />,
            path: "/owner-store",
            activePaths: [
              "/owner-store",
              "/owner-store-add",
              "/owner-store-update",
            ],
          },
          {
            name: t("store"),
            icon: <PersonBadge />,
            path: "/store",
            activePaths: ["/store", "/add-store", "/update-store"],
          },
          { name: t("category"), icon: <Layers />, path: "/category" },
          { name: t("units"), icon: <Boxes />, path: "/units" },
          // { name: t("customers"), icon: <People />, path: "/customers" },
          {
            name: t("products"),
            icon: <People />,
            path: "/products",
            activePaths: ["/products", "/products-add", "/products-update"],
          },

          ...(Number(auth?.user?.role_id) === Number(CONFIG.ROLE_OWNER)
            ? [
                {
                  name: t("order"),
                  icon: <People />,
                  path: "/all-store-owner-order-list",
                  activePaths: [
                    "/all-store-owner-order-list",
                    "/all-store-owner-order-details",
                  ],
                },

               
              ]
            : []),
        ]
      : []),

    ...(Number(auth.user.role_id) === CONFIG.ROLE_CUSTOMER
      ? [
          {
            name: t("store"),
            icon: <People size={18} />,
            path: "/customer-store",
          },
          {
            name: t("order"),
            icon: <Boxes size={18} />,
            path: "/order",
            activePaths: ["/order", "/order/details"],
          },
        ]
      : []),
  ];

  const role_id = Number(auth.user.role_id);

  let mainNav = [];
  let moreItems = [];

  if (role_id === CONFIG.ROLE_OWNER) {
    const allowedPaths = [
      "/dashboard",
      "/store",
      "/all-store-owner-order-list",
      "/products",
      "/category",
    ];

    mainNav = navItemsFull.filter((item) => allowedPaths.includes(item.path));

    // moreItems = navItemsFull.filter(
    //   (item) => !allowedPaths.includes(item.path)
    // );
  } else {
    mainNav = navItemsFull.slice(0, 4);
    moreItems = navItemsFull.slice(4);
  }

  // 1. Updated Active Index to include "More" button in logic if needed
  const activeIndex = mainNav.findIndex((item) =>
    isRouteActive(item.activePaths || [item.path]),
  );

  const generatePath = (index, total) => {
    if (index === -1) return "M0,20 L400,20 L400,80 L0,80 Z";

    const width = 400;
    const height = 80;

    const totalSlots = moreItems.length > 0 ? total + 1 : total;
    const sectionWidth = width / totalSlots;
    const centerX = sectionWidth * index + sectionWidth / 2;

    const curveWidth = 55; // Was 70, now tighter
    const dipWidth = 35; // Was 45
    const dipDepth = 55;

    return `
    M 0,20 
    L ${centerX - curveWidth},20 
    C ${centerX - dipWidth},20 ${centerX - dipWidth},${dipDepth} ${centerX},${dipDepth} 
    C ${centerX + dipWidth},${dipDepth} ${centerX + dipWidth},20 ${centerX + curveWidth},20 
    L ${width},20 
    L ${width},${height} 
    L 0,${height} 
    Z
  `;
  };

  const isMoreActive =
    showMore || moreItems.some((item) => isRouteActive([item.path]));

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50">
      {showMore && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={() => setShowMore(false)}
        />
      )}

      {moreItems.length > 0 && (
        <div
          className={`fixed left-4 right-4 bg-white dark:bg-slate-800 rounded-3xl shadow-2xl p-5 z-50 transition-all duration-300 ${
            showMore
              ? "bottom-24 opacity-100"
              : "bottom-10 opacity-0 pointer-events-none"
          }`}
        >
          <div className="grid grid-cols-3 gap-3">
            {moreItems.map((item) => (
              <button
                key={item.name}
                onClick={() => {
                  navigate(item.path);
                  setShowMore(false);
                }}
                className="flex flex-col items-center gap-2 p-4 rounded-2xl bg-orange-50"
              >
                <div className="text-brand-orange">{item.icon}</div>
                <span className="text-xs">{item.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* NAVBAR */}
      <nav className="fixed bottom-0 left-0 right-0 h-20 z-50 flex justify-around items-end pb-3">
        {" "}
        <div className="absolute inset-0 w-full h-full -z-10">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 400 80"
            preserveAspectRatio="none"
            className="fill-white dark:fill-slate-900 drop-shadow-[0_-10px_25px_rgba(0,0,0,0.08)]"
          >
            <path
              d={generatePath(activeIndex, mainNav.length)}
              className="transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)]"
            />
          </svg>
        </div>
        {/* NAV ITEMS */}
        {mainNav.map((item, index) => {
          const isActive = index === activeIndex;

          return (
            <button
              key={item.name}
              onClick={() => {
                navigate(item.path);
                setShowMore(false);
              }}
              className="relative flex flex-col items-center flex-1 h-full"
            >
              <div>
                <div className="relative flex flex-col items-center justify-center w-full h-16">
                  {isActive ? (
                    <>
                      <div className="absolute -top-5 w-16 h-16 bg-brand-orange rounded-full border-[6px] border-[#f8fafc] dark:border-slate-950 shadow-xl shadow-orange-500/40 flex items-center justify-center transition-all duration-500 animate-in zoom-in-75 ease-out">
                        <div className="text-white scale-110">
                          {React.cloneElement(item.icon, { size: 28 })}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="flex flex-col items-center gap-1 transition-all duration-300 translate-y-2 mt-4">
                      <div className="text-slate-400 dark:text-slate-500 opacity-70">
                        {React.cloneElement(item.icon, { size: 22 })}
                      </div>
                    </div>
                  )}
                </div>

                <span className="text-[10px] font-black text-slate-400 uppercase tracking-tighter block text-center transition-all">
                  {item.name}
                </span>
              </div>
            </button>
          );
        })}
        {moreItems.length > 0 && (
          <button
            onClick={() => setShowMore(true)}
            className="relative flex flex-col items-center flex-1 h-full pt-4"
          >
            {showMore ? (
              <div className="relative flex flex-col items-center justify-center w-full">
                <div className="absolute -top-12 w-16 h-16 bg-brand-orange rounded-full border-[6px] border-[#f8fafc] dark:border-slate-950 shadow-xl shadow-orange-500/30 flex items-center justify-center animate-in zoom-in-75 duration-300">
                  <div className="text-white">
                    <ThreeDots size={28} />
                  </div>
                </div>
                <div className="absolute top-6 w-1.5 h-1.5 bg-brand-orange rounded-full shadow-[0_0_8px_rgba(255,107,0,0.4)]" />
              </div>
            ) : (
              <div className="flex flex-col items-center gap-1 translate-y-4 transition-all duration-300">
                <ThreeDots size={22} className="text-slate-400" />
                <span className="text-[10px] font-black text-slate-400 uppercase tracking-tighter">
                  {t("more")}
                </span>
              </div>
            )}
          </button>
        )}
      </nav>
    </div>
  );
};

export default MobileBottomNav;
